/* ============================================================
   artvision® · FAVORITEN (Herz an Werkkarte und Werkseite)
   Firestore: collectors/{uid}/favorites/{shopifyProductId} mit
   nur { created_at: serverTimestamp() } — genau das, was
   firebase/firestore.rules im Dashboard-Repo erlaubt.
   Mechanik (Live-Zustand, Login, Resume-after-Auth):
   assets/av-collector-toggle.js.
   ============================================================ */

import { startCollectorToggle } from 'av-collector-toggle';
import { FAVORITES_COLLECTION, FAVORITE_TIMESTAMP_FIELDS, createFavoriteAction } from 'av-collector-core';

startCollectorToggle({
  name: 'Favorite',
  selector: '[data-av-favorite-toggle]',
  idAttribute: 'data-product-id',
  collection: FAVORITES_COLLECTION,
  timestampFields: FAVORITE_TIMESTAMP_FIELDS,
  actionType: 'favorite',
  createAction: createFavoriteAction,
  readActionId: (action) => action.productId
});
